module.exports = __webpack_public_path__ + "img/climbing-stairs.b10b9df.jpg";